import React, { useEffect, useState } from "react";
import { UseDisclosure } from "../../hooks/use-disclosure";

import cn from "classnames";
import Card from "../../components/Card";
import Form from "../../components/Form";
import Table from "./Table";
import styles from "./Table/Table.module.sass";
import tWallet from "../../i11/TokenWallet";
import HederaAccount from "./HederaAccount";
import TokenWalletModal from "../../components/TokenWalletModal";

import { UseApi } from "../../hooks/use-api";
import { useUser } from "../../context";
import { GetWalletNFTsAdmin } from "../../Services/lib/nft";

export const PageLimit = 8;
export const options = {
	SINGLE_EDITION: "Unique",
	LIMITED_EDITION: "Standard",
	AUCTION_EDITION: "Auction",
};
const TokenWallet = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [search, setSearch] = useState("");
	const [product, setProduct] = useState();
	const [page, setPage_] = useState(1);
	const [total, setTotal] = useState(1);
	const [{ isLoading }, getNFTs] = UseApi({
		service: GetWalletNFTsAdmin,
	});
	const [nft, setNft] = useState([]);
	const [filter, setFilter] = useState({
		limit: PageLimit,
		search: "",
		order_direction: -1,
		order_by: "createdAt",
	});

	const getWallet = async () => {
		setNft([]);
		const res = await getNFTs(filter);
		if (res) {
			setNft(res.list);
			setTotal(Math.ceil(res.list_count / PageLimit));
		}
	};
	useEffect(() => {
		getWallet();
	}, [filter]);

	const setPage = (e) => {
		setPage_(e);
		setFilter((p) => {
			return {
				...p,
				page: e,
			};
		});
	};

	const close = () => {
		setProduct();
		onClose();
	};

	const open = (data_) => {
		setProduct(data_);
		onOpen();
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (filter.search !== search) {
			setFilter((p) => {
				return {
					...p,
					search: search,
					page: 1,
				};
			});
		}
	};

	const prop = {
		items: nft,
		isLoading,
		page,
		total,
		filter,
		getWallet,
		setPage_,
		setFilter,
		setPage,
		open,
	};
	return (
		<>
			<HederaAccount />
			<Card
				title={tWallet[locale].tokens}
				classTitle={cn("title-blue", styles.title)}
				classCardHead={styles.head}
				head={
					<>
						<Form
							placeholder={tWallet[locale].search}
							type="text"
							name="search"
							icon="search"
							required={false}
							value={search}
							setValue={setSearch}
							onSubmit={onSubmit}
						/>
					</>
				}
			>
				<Table {...prop} />
			</Card>
			<TokenWalletModal
				visible={isOpen && product}
				onClose={close}
				data={product}
			/>
		</>
	);
};

export default TokenWallet;
